import React, { useEffect } from 'react';

const Resume = () => {
  useEffect(() => {
    document.title = "Khalil Ahmad - Resume";
  }, []);

  return (
    <div style={{ 
      height: '100vh', 
      width: '100vw', 
      margin: 0, 
      padding: 0, 
      overflow: 'hidden',
      backgroundColor: '#05070f'
    }}>
      <iframe 
        src="/Resume/Khalil_Ahmad_Resume.pdf#toolbar=1" 
        title="Khalil Ahmad - Resume"
        style={{ 
          width: '100%', 
          height: '100%', 
          border: 'none',
          display: 'block'
        }}
      />
    </div>
  );
};

export default Resume;
